import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import BadgeCDS from '@sharedCR/coreDesignSystem/BadgeCDS';
import _ from 'lodash';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { formatDate } from 'utils/date';

import { selectWireInstructionConfirmation } from 'store/loanApplications/selectors';

import {
  WireConfirmationBadgeColor,
  WireConfirmationBadgeLabel,
  WireConfirmationStatus,
} from './WireConfirmationBadge.constants';
import { wireConfirmationWrapperStyles } from './WireConfirmationBadge.styles';

const WireConfirmationBadge = () => {
  const wireConfirmation = useSelector(selectWireInstructionConfirmation);

  if (_.isNil(wireConfirmation)) {
    return null;
  }

  const { status, confirmedDate, rejectionReason } = wireConfirmation;
  const label = WireConfirmationBadgeLabel[status];
  const color = WireConfirmationBadgeColor[status];

  if (_.isNil(label)) {
    return null;
  }

  return (
    <Box sx={wireConfirmationWrapperStyles}>
      <BadgeCDS colorVariant={color} value={label} />
      {status === WireConfirmationStatus.CONFIRMED && confirmedDate && (
        <Typography color="text.secondary" variant="regular12">
          Confirmed on {formatDate(confirmedDate, COMMON_DATETIME_FORMAT)}
        </Typography>
      )}
      {status === WireConfirmationStatus.REJECTED && rejectionReason && (
        <Typography color="text.secondary" variant="regular12">
          Reason: {rejectionReason}
        </Typography>
      )}
    </Box>
  );
};

export default WireConfirmationBadge;
